import { render, staticRenderFns } from "./RegisterOrganization.vue?vue&type=template&id=45f4457b"
import script from "./RegisterOrganization.vue?vue&type=script&lang=js"
export * from "./RegisterOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports